import { useEffect, useState } from 'react';
import { getAdventureMusicEngine } from './adventureMusicEngine';

/**
 * Subscribe to the shared adventure music engine without forcing re-renders
 * on audio scheduling — only UI state changes notify React.
 */
export default function useAdventureMusic() {
  var engine = getAdventureMusicEngine();
  var _state = useState(function () {
    return engine.getState();
  });
  var state = _state[0];
  var setState = _state[1];

  useEffect(function () {
    return engine.subscribe(setState);
    // Engine is a module singleton; setState identity is stable enough here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    playing: state.playing,
    muted: state.muted,
    unlocked: state.unlocked,
    reducedMotion: state.reducedMotion,
    play: function () {
      engine.play();
    },
    pause: function () {
      engine.pause();
    },
    togglePlay: function () {
      engine.togglePlay();
    },
    toggleMute: function () {
      engine.toggleMute();
    },
    unlockFromGesture: function () {
      engine.unlockFromGesture();
    },
  };
}
